/**
 * 接口请求的封装
 */

import axios from 'axios';
import env from '@/api/env';
import notLoad from '@/api/notLoad';
import {Message, Loading} from 'element-ui';
import store from '@/store/store';
import router from '@/router/router';
import {removeToken} from '@/utils/auth';

const ENV = process.env.NODE_ENV === 'production' ? env.PROD_ENV : env.PROD_ENV;

let loadingInstance;
const service = axios.create({
    baseURL: ENV,
    origin: ENV,
    headers: {"Content-Type": "multipart/form-data"}
});

// 公共请求接口
service.interceptors.request.use(config => {
    let notLoadParams = config.data.servername + '::' + config.data.method;
    // 每次请求token绑在data上
    config.data['token'] = store.getters.token ? store.getters.token : null;
    if (notLoad.notLoadIcon.indexOf(notLoadParams) == -1) {
        loadingInstance = Loading.service({fullscreen: true})
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// 接口返回
service.interceptors.response.use(response => {
    if (response.data.code == 1005) {
        // 登录失效
        removeToken();
        store.commit('REMOVE_TOKEN');
        router.replace('/login');
    }

    if (response.data.code == 1007) {
        Message({
            type: 'error',
            message: response.data.msg,
            duration: 3 * 1000
        });
    }

    if (loadingInstance) {
        loadingInstance.close();
    }

    return response;
}, error => {
    return Promise.reject(error);
});

export default service;